import { memo } from "react";
import ChevronRightIcon from "./images/icons/chevron-right.svg?react";
import "./GalleryGifNav.scss";

interface IGalleryGifNavProps {
  slidePrevArrow: React.RefObject<HTMLButtonElement>;
  slideNextArrow: React.RefObject<HTMLButtonElement>;
  sliderPagination: React.MutableRefObject<HTMLDivElement | null>;
}

export const GalleryGifNav: React.FC<IGalleryGifNavProps> = memo(({
  slidePrevArrow,
  slideNextArrow,
  sliderPagination
}) => {
  return (
    <div className="GalleryGifNavV2">
      <button ref={slidePrevArrow} aria-label="previous slide button">
        <ChevronRightIcon />
      </button>
      <div className="GalleryGifNavV2-Dots" ref={sliderPagination} />
      <button ref={slideNextArrow} style={{ transform: "rotate(180deg)" }} aria-label="next slide button">
        <ChevronRightIcon />
      </button>
    </div>
  );
});

